$('.hb-banner-grid').slick({
  dots: true,
  infinite: false,
  speed: 500,
  infinite: true,
  // autoplay: true,
  autoplaySpeed: 2000,
  slidesToShow: 1,
  arrows: false,
  slidesToScroll: 1,
});



$('.collection-slider').slick({
  dots: false,
  infinite: true,
  // autoplay: true,
  autoplaySpeed: 2000,
  speed: 300,
  slidesToShow: 4,
  arrows: true,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
  ]
});


// $(document).ready(function(){
//    $(".cd-warranty-help").addClass("active");
//    $(".btn-assist").addClass("active");
//   $(".btn-warranty-help").click(function(){
//     $(".cd-product-assist").addClass("active");
//      $(".cd-warranty-help").removeClass("active");
//      $(".btn-warranty-help").addClass("active");
//      $(".btn-assist").removeClass("active");
//   });
//    $(".btn-assist").click(function(){
//     $(".cd-warranty-help").addClass("active");
//     $(".cd-product-assist").removeClass("active");
//     $(".btn-assist").addClass("active");
//     $(".btn-warranty-help").removeClass("active");
//   });
// });

$(document).ready(function () {

  function showTab(tab) {
    if (tab === "product-assist") {
      $(".cd-product-assist").addClass("active");
      $(".cd-warranty-help").removeClass("active");

      $(".btn-warranty-help").addClass("active");
      $(".btn-assist").removeClass("active");
    } else {
      $(".cd-warranty-help").addClass("active");
      $(".cd-product-assist").removeClass("active");

      $(".btn-assist").addClass("active");
      $(".btn-warranty-help").removeClass("active");
    }
  }

  // Page reload ke baad last active tab open rahega
  let activeTab = localStorage.getItem("activeHelpTab") || "warranty-help";
  showTab(activeTab);

  $(".btn-warranty-help").click(function () {
    localStorage.setItem("activeHelpTab", "product-assist");
    showTab("product-assist");
  });

  $(".btn-assist").click(function () {
    localStorage.setItem("activeHelpTab", "warranty-help");
    showTab("warranty-help");
  });

  // Shopify form submit hone se pehle active tab save kar do
  $(".cd-product-assist form").on("submit", function () {
    localStorage.setItem("activeHelpTab", "product-assist");
  });

  $(".cd-warranty-help form").on("submit", function () {
    localStorage.setItem("activeHelpTab", "warranty-help");
  });

});

// filter FAQ section

document.addEventListener("DOMContentLoaded", function () {
  // Accordion functionality
  const faqItems = document.querySelectorAll('.faq-item');
  const faqToggles = document.querySelectorAll('.faq-toggle');
  
  faqToggles.forEach(function(toggle, index) {
    toggle.addEventListener('click', function() {
      const item = faqItems[index];
      item.classList.toggle('open');
      // toggle.textContent = item.classList.contains('open') ? '' : '';
    });
  });

  // Filtering functionality
  const filterButtons = document.querySelectorAll('.faq-filter-btn');

  // Set "View All" as default
  const viewAllButton = document.querySelector('.faq-filter-btn[data-filter="all"]');
  if (viewAllButton) {
    viewAllButton.classList.add('active'); // Mark the "View All" filter as active
  }

  // Show all FAQ items when "View All" is clicked or selected by default
  faqItems.forEach(function(item) {
    item.style.display = 'block'; // Ensure all FAQ items are visible by default
  });

  filterButtons.forEach(function(button) {
    button.addEventListener('click', function() {
      const filter = button.getAttribute('data-filter');

      // Mark active filter button
      filterButtons.forEach(function(btn) {
        btn.classList.remove('active');
      });
      button.classList.add('active');

      // Show/Hide FAQ items based on the selected filter
      faqItems.forEach(function(item) {
        const category = item.classList.contains('faq-category-' + filter) || filter === 'all';
        item.style.display = category ? 'block' : 'none';
      });
    });
  });
});


// blog heading ink scroll*********************************************************
document.addEventListener("DOMContentLoaded", function () {
  // Get the article content
  var articleContent = document.querySelector('.article-content');
  
  // Get all h2 headings inside article content
  var headings = articleContent.querySelectorAll('h2');
  
  // Get the sidebar where links will be added
  var sidebar = document.getElementById('cd-blog-topic-heading-link');
  
  // Loop through each h2 and create a corresponding link
  headings.forEach(function (heading, index) {
    // Create a unique ID for each heading
    var headingId = 'heading-' + index;
    heading.setAttribute('id', headingId);
    
    // Create a link element
    var link = document.createElement('a');
    link.href = '#' + headingId;
    link.textContent = heading.textContent;
    link.classList.add('sidebar-link');
    
    // Append the link to the sidebar
    sidebar.appendChild(link);
    
    // Add a line break after each link for better readability
    sidebar.appendChild(document.createElement('br'));
  });

  // Add smooth scrolling when a sidebar link is clicked
  sidebar.addEventListener('click', function (event) {
    // Check if the clicked element is a link
    if (event.target && event.target.matches('a.sidebar-link')) {
      var targetId = event.target.getAttribute('href').substring(1);
      var targetElement = document.getElementById(targetId);
      
      // Scroll to the target element
      targetElement.scrollIntoView({
        behavior: 'smooth'
      });
      
      // Prevent the default behavior of the link
      event.preventDefault();
    }
  });
});



// varient active class

document.addEventListener('DOMContentLoaded', function () {
  function updateActiveVariantClass() {
    document.querySelectorAll('.custom-variant-option--swatch').forEach(function(option) {
      const radio = option.querySelector('input[type="radio"]');
      
      if (radio && radio.checked) {
        option.classList.add('active');
        option.classList.add('checked');
      } else {
        option.classList.remove('active');
        option.classList.remove('checked');
      }
    });
  }

  // Initial load par
  updateActiveVariantClass();

  // Radio change par
  document.addEventListener('change', function(e) {
    if (e.target.matches('.custom-variant-option--swatch input[type="radio"]')) {
      updateActiveVariantClass();
    }
  });
});

